import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  vapidKey: null,
  loading: false,
  sidebarVisible: true,
  showMobileSidebar: false,
  unsavedChanges: false
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setVapidKey(state, action) {
      state.vapidKey = action.payload;
    },
    setLoading(state, action) {
      console.log("Setting loading state to:", action.payload);
      state.loading = action.payload;
    },
    setSidebarVisible(state, action) {
      state.sidebarVisible = action.payload;
    },
    setShowMobileSidebar(state, action) {
      state.showMobileSidebar = action.payload;
    },
    setUnsavedChanges(state, action) {
      state.unsavedChanges = action.payload;
    }
  },
});

export const { setVapidKey, setLoading, setSidebarVisible, setShowMobileSidebar, setUnsavedChanges } = appSlice.actions;
export default appSlice.reducer;
